import { render } from "./productLayoutSimple.vue?vue&type=template&id=096f3bd6&scoped=true&ts=true"
import script from "./productLayoutSimple.vue?vue&type=script&lang=ts"
export * from "./productLayoutSimple.vue?vue&type=script&lang=ts"

import "./productLayoutSimple.vue?vue&type=style&index=0&id=096f3bd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096f3bd6"]])

export default __exports__